import React, { useEffect, useState,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import Pagination from '../Common/Pagination';
import ReactSelect from 'react-select';
import { Context } from '../../context/UserContext';
import ReactInputMask from 'react-input-mask';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('Person/GetAllPersons');
    const { addData: updateData } = useEntityCrud('Person/ChangeStatus');
    const [rows, setRows] = useState([]);
    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);


    const [nationalCode, setNationalCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [branchId, setBranchId] = useState(0);
    const [branchs, setBranchs] = useState([]);
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    const [searched, setSearched] = useState(false);

    const [lastPage,setLastPage] = useState(0);
    const [count,setCount] = useState(0);

    const getData = (searchData) => {
         
        const postedData = {
            name: '',
            lastName: '',
            nationalCode: '',
            phone: '',
            cellphone: '',
            email: '',
            branchTitle: '',
            branchId: 0,
            offset: 0,
            limit: 10,
            ...searchData
        };
        readData(postedData).then(res => {
             
            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result);
            } else {
                setRows([]);
                setPages([]);
            }
        })
    }

    useEffect(() => {
        getData();

        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })

    }, [])

    const downloadExcel = () => {
        document.getElementById('download-excel').classList.add('btn-loading');
        const postedData = {
            excelOutput: true
        };
        if(firstName)
            postedData.name = firstName;
        if(lastName)
            postedData.lastName = lastName;
        if(nationalCode)
            postedData.nationalCode = nationalCode;
        if(mobile)
            postedData.cellphone = mobile;
        if(branchId)
            postedData.branchId = branchId;
        readData(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath);
        }).finally(() => {
            document.getElementById('download-excel').classList.remove('btn-loading');
        });
    };

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        setCount(res.data.count)

        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        
        const postedData = {};
        if (firstName)
            postedData.name = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (mobile)
            postedData.cellphone = mobile;
        if (branchId)
            postedData.branchId = branchId;

        readData({
            name: '',
            lastName: '',
            nationalCode: '',
            phone: '',
            cellphone: '',
            email: '',
            branchTitle: '',
            limit: 10,
            offset: page - 1,
            ...postedData
        }).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);

        const postedData = {};
        if (firstName)
            postedData.name = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (mobile)
            postedData.cellphone = mobile;
        if (branchId)
            postedData.branchId = branchId;

        readData({
            name: '',
            lastName: '',
            nationalCode: '',
            phone: '',
            cellphone: '',
            email: '',
            branchTitle: '', limit: 10, offset: currentPage - 2 ,
            ...postedData
        }).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);

        const postedData = {};
        if (firstName)
            postedData.name = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (mobile)
            postedData.cellphone = mobile;
        if (branchId)
            postedData.branchId = branchId;

        readData({
            name: '',
            lastName: '',
            nationalCode: '',
            phone: '',
            cellphone: '',
            email: '',
            branchTitle: '', limit: 10, offset: currentPage ,
            ...postedData
        }).then(res => {
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت پرسنل مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !oldRows[index].isActive;
                setRows([...oldRows]);
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت پرسنل مورد نظر با موفقیت به روزرسانی شد');
                const oldRows = [...rows];
                const index = oldRows.findIndex(row => row.id == id);
                oldRows[index].isActive = !oldRows[index].isActive;
                setRows([...oldRows]);
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const searchData = e => {
        if(e)
            e.preventDefault();
        const postedData = {};
        if (firstName)
            postedData.name = firstName;
        if (lastName)
            postedData.lastName = lastName;
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (mobile)
            postedData.cellphone = mobile.toString().replace('-','');
        if (branchId)
            postedData.branchId = branchId;
        getData(postedData);
        setSearched(true);
    }
 
    const clearSearch = e => {
        e.preventDefault();
        setNationalCode('');
        setMobile("");
        setFirstName("");
        setLastName("");
        setSearched(false);
        getData({});
    }
     return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">پرسنل</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد پرسنل</Link> : ''}
                <button className="btn btn-dark mx-2 accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                <button className="btn btn-success" id="download-excel" aria-expanded="false" onClick={downloadExcel}>دریافت خروجی اکسل</button>

                <div className="panel-group1" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                        <form onSubmit={e => searchData(e)} className="row mt-4">

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>  نام	   </label>
                                    <input type="text" className="form-control " value={firstName} onChange={e => setFirstName(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>  نام خانوادگی	   </label>
                                    <input type="text" className="form-control " value={lastName} onChange={e => setLastName(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شماره همراه	   </label>
                                    <ReactInputMask className="form-control ltr-input" mask="0999-9999999" value={mobile} onChange={e => setMobile(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی</label>
                                    <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شرکت    </label>
                                    {branchId ? <i className="fe fe-x clear-select-btn" onClick={e => setBranchId('')}></i> : ''}
                                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="  همه موارد " options={branchs} value={branchs.filter(b => b.value == branchId)} onChange={e => setBranchId(e.value)} />
                                </div>
                            </div>

                            <div className="col-md-2" style={{ marginTop: 30 }}>
                                <button className="btn btn-success me-2">جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </form>
                    </div>
                </div>
                <hr />
                {rows.length ?
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                            <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>نام</th>
                                    <th>نام خانوادگی</th>
                                    <th>کد ملی</th>
                                    <th>شماره تماس</th>
                                    <th>شماره همراه</th>
                                    <th>آدرس ایمیل</th>
                                    <th>نام شرکت</th>
                                    <th>وضعیت</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                        <td>{item.name}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.nationalCode}</td>
                                        <td>{item.phone}</td>
                                        <td>{item.cellphone}</td>
                                        <td>{item.email}</td>
                                        <td>{item.branchTitle}</td>
                                        <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                        <td className="btn-list">
                                            {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                            {context.checkHasPermission('delete') ? (item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <p>تعداد کل ردیف ها : {count || 0}</p>

                        <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                    </div>
                    :
                    <div className="alert alert-info"><p>پرسنلی یافت نشد</p></div>}
            </div>
        </div>
    );
}

export default Index;